// extracted by mini-css-extract-plugin
export default {"box":"index_box_4xpyI","ad":"index_ad_BPFkD","tuijianTitle":"index_tuijianTitle_EQMh9","tuijian":"index_tuijian_cYwpO"};